import { render, staticRenderFns } from "./yearStock.vue?vue&type=template&id=6a3430cf"
import script from "./yearStock.vue?vue&type=script&lang=js"
export * from "./yearStock.vue?vue&type=script&lang=js"
import style0 from "./yearStock.vue?vue&type=style&index=0&id=6a3430cf&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports